import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { OrderFormValues } from "../lib/contexts/FormikContext";
import { Useplace } from "../lib/types";

type Props = {
  address: Useplace;
};

export const AddressBar = (props: Props) => {
  const { address } = props;
  const { values, submitForm, setFieldValue } =
    useFormikContext<OrderFormValues>();

  useEffect(() => {
    setFieldValue("useplace", address?.id);
    setFieldValue("site", address?.site.id);
  }, []);
  return (
    <div
      className="py-4 px-8 max-w-6xl m-auto text-white rounded-lg"
      style={{ background: "#374F5A" }}
    >
      <div className="flex flex-row justify-between items-center">
        <div className="flex flex-row gap-8 items-center">
          <div className="w-4 text-2xl">
            <FontAwesomeIcon icon={faLocationDot} />
          </div>
          <div className="flex flex-col">
            <div>
              {`${address?.address}
              ${address?.streetno}${address?.floor}, ${
                address?.apartment ? `lgh ${address?.apartment} ,` : ""
              } ${address?.zip} ${address?.city}`}
              <div className="inline ml-8">{address?.site.propertyid}</div>
            </div>
            <div className="mt-1 text-xs opacity-70">
              Adressen är{" "}
              <strong>
                {address?.site.installation === "installed"
                  ? "ansluten"
                  : "inte ansluten"}
              </strong>{" "}
              till Lunets stadsnät.
            </div>
          </div>
        </div>
        <div>
          <Link to="/" className="btn btn-primary">
            Ny sökning
          </Link>
        </div>
      </div>
    </div>
  );
};
